import { observer } from 'mobx-react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { OptionsCheckbox } from 'owa-options-controls';
import { Link } from 'office-ui-fabric-react/lib/Link';
import * as React from 'react';
import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import selectLocaleOption from '../data/mutators/selectLocaleOption';
import setRenameFoldersOption from '../data/mutators/setRenameFoldersOption';
import strings from 'owa-strings/owa-options-strings';
import { isFeatureEnabled } from 'owa-feature-flags';

let styles = require('./Regional.scss');

@observer
export default class CultureSelection extends React.Component<{}, {}> {
    render() {
        let store = getRegionalOptions();

        return (
            <div>
                <Dropdown
                    label={strings.option_regional_language}
                    options={store.supportedCultures.map(culture => ({
                        text: culture.NativeName,
                        key: culture.Name,
                    }))}
                    selectedKey={
                        store.selectedLocale || getUserConfiguration().SessionSettings.UserCulture
                    }
                    onChanged={this.onSelectLocale}
                    onRenderOption={this.onRenderOption}
                    styles={{ label: styles.dropdown }}
                />
                {store.selectedLocale !== null &&
                    store.selectedLocale !== getUserConfiguration().SessionSettings.UserCulture && (
                        <OptionsCheckbox
                            className={styles.renameFolders}
                            onChange={this.toggleRenameFolders}
                            label={strings.option_regional_renameDefaultFolders}
                            checked={store.shouldRenameDefaultFolders}
                        />
                    )}
                {store.hasUserChangedLanguage && (
                    <Link onClick={this.reloadPage} className={styles.reloadButton}>
                        {isFeatureEnabled('fwk-localeHotReload')
                            ? strings.option_regional_languageHotReload
                            : strings.option_regional_languageReload}
                    </Link>
                )}
            </div>
        );
    }

    private toggleRenameFolders(
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) {
        setRenameFoldersOption(checked);
    }

    private reloadPage() {
        location.reload();
    }

    private onSelectLocale(item: IDropdownOption) {
        selectLocaleOption(item.key as string);
    }

    // Creating custom render option because of ltr/rtl options in this dropdown
    private onRenderOption = (item: IDropdownOption): JSX.Element => {
        return <bdi>{item.text}</bdi>;
    };
}
